import { GlideFC } from "lib/glide-fc";
import ActionModal from "../../smart/action-modal/action-modal";
import { styled } from "sharedUI/styles";
import copy from "copy-to-clipboard";
import { getDocURL } from "common/docUrl";
import { getNamedIcon } from "common/named-icons";
import WindowedModalV2 from "designer/modals-v2/windowed-modal/windowed-modal";

export const GetSupportModalStyle = styled.div`
    position: relative;
    color: ${p => p.theme.fgColorDark};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .description {
        display: inline;
    }
    .linkWarning {
        padding-top: 20px;
        font-size: 14px;
    }
    .quicklink {
        color: ${p => p.theme.acceptColor};
    }
    .applink {
        display: flex;
        align-items: center;
        color: ${p => p.theme.fgColorMedium};
        text-decoration: none;
        margin: 20px 0;
        cursor: pointer;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0);
        transition: 150ms ease-in-out;
        transition-property: transform box-shadow;
        transform: scale(1);
        :hover {
            transform: scale(1.01);
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
        }
        :active {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
            content: "Copied";
            transform: scale(0.99);
        }

        p {
            font-size: 12px;
            margin: 0;
            padding-right: 10px;
        }
    }
`;

const CopyLinkIcon = getNamedIcon("copyLink");

interface SupportModalProps {
    appLink: string;
    closeModal(): void;
}

export const SupportModal: GlideFC<SupportModalProps> = props => {
    const { appLink, closeModal } = props;

    return (
        <WindowedModalV2 canClose={true} onClose={closeModal} hideClosingButton={true}>
            <ActionModal
                header="Copy Support Link"
                description={
                    <GetSupportModalStyle>
                        <div className="description">
                            Please share this link with Glide Support to grant temporary access to your app:
                        </div>
                        <span
                            className="applink"
                            onClick={() => {
                                copy(appLink);
                            }}>
                            <p>{appLink}</p>
                            <CopyLinkIcon />
                        </span>
                        <div className="description">
                            Support is not available for Personal apps. If you need help with your app, please visit the{" "}
                            <a
                                className="quicklink "
                                href={`https://community.glideapps.com`}
                                title="community"
                                target="_blank"
                                rel="noopener noreferrer">
                                Community Forum
                            </a>
                            .{" "}
                            <a
                                className="quicklink learnmore"
                                href={getDocURL("supportCodes")}
                                title="learm more"
                                target="_blank"
                                rel="noopener noreferrer">
                                Learn more about support links
                            </a>
                            .
                        </div>
                    </GetSupportModalStyle>
                }
                acceptText="Done"
                acceptAction={closeModal}
            />
        </WindowedModalV2>
    );
};
